import styled from "styled-components";
import Div, { Flex } from "../division";
import { Row } from "../../grids/Grids";
import { Column } from "../../grids/Grids";

export const TableWrapper = styled(Div)`
  padding-top: ${(props) => props.paddingTop};
  padding-left: ${(props) => props.paddingLeft};
  padding-right: ${(props) => props.paddingLeft};
  background: ${(props) => props.background};
`;

//TODO need to dynamically change padding according to responsive table UX
export const HeaderComponent = styled(Row)`
justify-content: ${(props) => props.justifyContent};
  border: ${(props) => props.border};
  background: ${(props) => props.background};
  padding-top: ${(props) => props.theme.padding12};
  padding-bottom: ${(props) => props.theme.padding12};
  width: 100%;
  box-sizing: border-box;
  ${props=>{
    let style = {
      padding: props.justifyContent ? "12px 82px" : "12px"
    }
    return {
      ...style
    }
  }}
  > div {
    ${props=>{
      let style = {
        width: props.justifyContent ? "auto" : ""
      }
      return {
        ...style
      }
    }}
    background: ${(props) => props.background};
    color: ${(props) => props.color};
    font-weight: ${(props) =>
      props.fontWeight ? props.fontWeight : props.theme.fontBold};
    font-size: ${(props) =>
      props.fontSize ? props.fontSize : props.theme.font12};
    justify-content: left;
  }
  & > div:nth-child(3){
    overflow: hidden;
    white-space: nowrap;
  }
  & > div:nth-child(4){
    justify-content:flex-start;
    }
    & > div:nth-child(5){
    justify-content: flex-start;
      }
`;
export const BodyComponent = styled(Div)`
  background: ${(props) => props.background};
  height: ${(props) => props.height};
  overflow-y: scroll;
  justify-content: flex-start;
  box-sizing: border-box;
  display: block;
`;
//TODO need to dynamically change padding according to responsive table UX
export const RowComponent = styled(Row)`
  border-right: ${(props) => props.border};
  border-bottom: ${(props) => props.border};
  border-left: ${(props) => props.border};
  border-top: ${(props) => props.border};
  padding-top: ${(props) =>
    props.padding ? props.padding : props.theme.padding12};
  padding-bottom: ${(props) =>
    props.padding ? props.padding : props.theme.padding12};
  flex-direction: row;
  background-color: ${(props) =>
    props.markAsRead && props.markAsRead === true
      ? props.theme.baseColor
      : props.background
      ? props.background
      : props.theme.transparent};
      position: ${(props) => props.position} ;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${(props) => props.theme.baseColor};
    #alarmInfoWrapper,
    #alarmInfoWrapperText {
      background-color: ${(props) => props.theme.baseColor};
    }
  }
  box-sizing: border-box;
  > div {
    color: ${(props) => props.color};
    font-size: ${(props) => props.fontSize};
  }
`;

export const Loader = styled(Div)`
  align-items: center;
  border: none !important;
  padding-top: ${(props) => props.theme.padding12};
`;

export const Widgets = styled(Column)`
  justify-content: flex-end !important;
`;

export const UpSortArrow = styled(Column)`
  display: inline-block;
  width: ${(props) => props.theme.margin0};
  height: ${(props) => props.theme.margin0};
  margin: ${(props) => props.theme.margin2};
  border-left: ${(props) => props.theme.margin4} solid transparent;
  border-right: ${(props) => props.theme.margin4} solid transparent;
  border-bottom: ${(props) => props.theme.margin4} solid
    ${(props) => props.theme.darkGrey};
`;

export const DownSortArrow = styled(Column)`
  display: inline-block;
  width: ${(props) => props.theme.margin0};
  height: ${(props) => props.theme.margin0};
  margin: ${(props) => props.theme.margin2};
  border-left: ${(props) => props.theme.margin4} solid transparent;
  border-right: ${(props) => props.theme.margin4} solid transparent;
  border-top: ${(props) => props.theme.margin4} solid
    ${(props) => props.theme.darkGrey};
`;
